import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './components/reducers/mainReducer';
import { Toaster } from 'react-hot-toast';
import 'react-toastify/dist/ReactToastify.css';

const store = configureStore({
  reducer: rootReducer
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
      <Toaster
        position="top-center"
        reverseOrder={false}
      />
    </BrowserRouter>
  </Provider>
);


